#import "./field-fragment.graphql"
#import "./create-rules-fragment.graphql"
#import "./form-stub-fragment.graphql"
#import "./next-steps-fragment.graphql"

fragment FormFragment on Form {
    ...FormStubFragment
    isLiveForm
    publishedFormPreviewUrl
    sharableViewInBrowserLink
    hasUnpublishedChanges
    editableVersion {
        id
        fields {
            ...FieldFragment
        }
        styles
        redirectUrl
        afterSubmissionText
        hasContactFields
        hasAccountFields
        hasLeadFields
    }
    spamPreventionType
    createRules {
        ...CreateRulesFragment
    }
    nextSteps {
        ...NextStepsFragment
    }
    publishedVersion {
        id
        fields {
            ...FieldFragment
        }
        styles
        redirectUrl
        afterSubmissionText
    }
    embedSnippet
    type
}
